module.exports = __webpack_public_path__ + "static/media/volcanBoarding.c4842753.JPG";